import { useEffect, useRef } from "react";

export default function OptionalTextField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  ...props
}) {
  const inputRef = useRef();
  const checkboxRef = useRef();
  const handleEnabledChange = (event) => {
    event.stopPropagation();
    if (!event.currentTarget.checked) {
      inputRef.current.disabled = true;
      if (inputRef.current.value !== "") {
        inputRef.current.value = "";
        inputRef.current.dispatchEvent(
          new Event("clear", {
            cancelable: true,
            bubbles: true,
            composed: false,
          }),
        );
      }
    } else {
      inputRef.current.disabled = false;
    }
  };
  const computedClassName = [
    "form-group",
    "optional",
    "text-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  useEffect(() => {
    const input = inputRef.current;
    const onEnabledChange = handleEnabledChange;
    const checkbox = checkboxRef.current;
    checkbox.addEventListener("change", onEnabledChange);
    input.addEventListener("clear", onChange);
    return () => {
      checkbox.removeEventListener("change", onEnabledChange);
      input.removeEventListener("clear", onChange);
    };
  }, [onChange]);
  useEffect(() => {
    const checkbox = checkboxRef.current;
    const input = inputRef.current;
    if (!!checkbox) {
      checkbox.checked = !!value;
    }
    if (!!input) {
      input.disabled = !value || disabled;
    }
  }, [value, disabled]);
  return (
    <div className={computedClassName} {...props}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <div className="input-group">
        <span className="input-group-addon">
          <input
            id={`${id}_enabled`}
            type="checkbox"
            ref={checkboxRef}
            disabled={disabled}
          />
        </span>
        <input
          id={id}
          ref={inputRef}
          name={name}
          type="text"
          value={value}
          className="form-control"
          onChange={onChange}
          aria-invalid={isInvalid}
          disabled={disabled}
        />
      </div>
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

OptionalTextField.defaultProps = {
  className: "",
  onChange: (event) => {},
  value: "",
};
